import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config';
import './Dashboard.css';

// ── existing icons unchanged ──
const IconCalendar = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="1" y="2" width="14" height="13" rx="2" strokeWidth="1.4" />
    <path d="M1 6h14" strokeWidth="1.4" />
    <path d="M5 1v2M11 1v2" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
const IconChevronDown = () => (
  <svg viewBox="0 0 10 10" fill="none" aria-hidden="true">
    <path d="M2 3.5L5 6.5L8 3.5" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
const IconExport = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M8 2v9M4 7l4 4 4-4" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 13h12" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
const IconLogout = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M10 11l3-3-3-3M13 8H6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// ── NEW: Bell icon ──
const IconBell = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" width="16" height="16">
    <path d="M8 1.5A4.5 4.5 0 003.5 6v3L2 11h12l-1.5-2V6A4.5 4.5 0 008 1.5z"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.5 11.5a1.5 1.5 0 003 0" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// ── type icon styles ──
const TYPE_STYLES = {
  'Micro':      { bg: '#EEF2FF', color: '#7c3aed' },
  'Mid-Scale':  { bg: '#F0FDF4', color: '#16a34a' },
  'Large':      { bg: '#FFF7ED', color: '#ea580c' },
  'Enterprise': { bg: '#FDF4FF', color: '#9333ea' },
};
const TYPE_ICONS = {
  'Micro':      '/people-skin-type.png',
  'Mid-Scale':  '/Organization_1.png',
  'Large':      '/business-building.png',
  'Enterprise': '/city-buildings.png',
};

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function openSidenav() {
  document.querySelector('.admin-sidenav')?.classList.add('open');
  document.querySelector('.sidenav-backdrop')?.classList.add('visible');
  document.body.style.overflow = 'hidden';
}
function closeSidenav() {
  document.querySelector('.admin-sidenav')?.classList.remove('open');
  document.querySelector('.sidenav-backdrop')?.classList.remove('visible');
  document.body.style.overflow = '';
}

export default function AdminTopNav({ title, subtitle, onYearChange, onExportPDF }) {
  const navigate    = useNavigate();
  const location    = useLocation();
  const userName = localStorage.getItem('userName') || 'Admin';
  const isDashboard = location.pathname === '/admin/dashboard';

  const currentYear = new Date().getFullYear();

  const [dropOpen,     setDropOpen]     = useState(false);
  const [startYear,    setStartYear]    = useState(currentYear);
  const [endYear,      setEndYear]      = useState(currentYear);
  const [startMonth,   setStartMonth]   = useState(0);
  const [endMonth,     setEndMonth]     = useState(11);
  const [pickStep,     setPickStep]     = useState('start');
  const [appliedLabel, setAppliedLabel] = useState(
    `${MONTHS[0]} ${currentYear} – ${MONTHS[11]} ${currentYear}`
  );
  const [exporting, setExporting] = useState(false);
  const dropRef = useRef();

  // ── NEW: reminder state ──
  const [reminderOpen, setReminderOpen]   = useState(false);
  const [reminderData, setReminderData]   = useState({ count: 0, organizations: [], reminderMonth: '' });
  const reminderRef                       = useRef();
  // ── ADD this state ──
const [reminderFilter, setReminderFilter] = useState('all'); // 'all' | 'this' | 'next'

  // fetch reminders on mount
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/admin/dashboard/reminders`)
      .then(res => setReminderData(res.data))
      .catch(err => console.error('Reminder fetch error:', err));
  }, []);

  // close reminder dropdown on outside click
  useEffect(() => {
    function handleClick(e) {
      if (reminderRef.current && !reminderRef.current.contains(e.target)) {
        setReminderOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    function handleClick(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => { closeSidenav(); }, [location.pathname]);

  const handleStartYearInput = (e) => {
    const yr = parseInt(e.target.value, 10);
    if (!isNaN(yr) && yr >= 2000 && yr <= 2100) {
      setStartYear(yr); setStartMonth(0); setEndMonth(null); setPickStep('start');
    }
  };
  const handleEndYearInput = (e) => {
    const yr = parseInt(e.target.value, 10);
    if (!isNaN(yr) && yr >= 2000 && yr <= 2100) {
      setEndYear(yr); setEndMonth(null); setPickStep('end');
    }
  };

 const handleLogout = () => {
 localStorage.removeItem('adminToken');
localStorage.removeItem('userName');
localStorage.removeItem('userEmail');
  closeSidenav();
  navigate('/admin/login');
};

  const handleApply = () => {
    const label = `${MONTHS[startMonth]} ${startYear} – ${MONTHS[endMonth]} ${endYear}`;
    setAppliedLabel(label);
    setDropOpen(false);
    if (onYearChange) onYearChange(startYear, startMonth, endYear, endMonth);
  };

  const handleExportPDF = async () => {
    if (exporting) return;
    const startStr = `${startYear}-${String(startMonth + 1).padStart(2, '0')}-01`;
    const endStr   = `${endYear}-${String(endMonth + 1).padStart(2, '0')}-${new Date(endYear, endMonth + 1, 0).getDate()}`;
    setExporting(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/admin/dashboard/export-pdf`,
        { params: { start: startStr, end: endStr }, responseType: 'blob' }
      );
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `dashboard-${appliedLabel}.pdf`);
      document.body.appendChild(link); link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error('PDF export failed:', err);
      alert('Export failed.');
    } finally {
      setExporting(false);
    }
  };

  const heading    = title    || (isDashboard ? `Welcome Back, ${userName}!` : '');
  const subheading = subtitle || (isDashboard ? "Here's what's happening with your organizations." : 'Forms and Submissions');

  return (
    <>
      <div className="sidenav-backdrop" onClick={closeSidenav} />
      <header className="admin-topnav">
        <button className="sidenav-hamburger" aria-label="Open navigation menu" onClick={openSidenav}>
          <span /><span /><span />
        </button>

        {/* logo shown in the dark top bar on mobile / tablet (hidden on desktop by CSS) */}
        <img src="/assets/lo.png" alt="Outstanding Workplaces" className="topnav-mobile-logo" />

        <div className="topnav-left">
          {heading    && <h1>{heading}</h1>}
          {subheading && <p>{subheading}</p>}
        </div>

        <div className="topnav-actions">
          {isDashboard && (
            <>
              {/* date picker — unchanged */}
              <div className="topnav-date-wrapper" ref={dropRef} style={{ position: 'relative' }}>
                <div className="topnav-date-btn" onClick={() => setDropOpen(o => !o)}>
                  <IconCalendar />{appliedLabel}<IconChevronDown />
                </div>
                {dropOpen && (
                  <div style={{
                    position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 999,
                    background: '#fff', border: '1px solid #ebedf2', borderRadius: 12,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)', width: 320, overflow: 'hidden',
                  }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: '1px solid #ebedf2', background: '#fafafa' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 14px', borderRight: '1px solid #ebedf2' }}>
                        <span style={{ fontSize: 11, color: '#a0aab8', textTransform: 'uppercase' }}>Start Year</span>
                        <input type="number" min="2000" max="2100" value={startYear} onChange={handleStartYearInput}
                          style={{ width: 60, border: '1px solid #e5e7eb', borderRadius: 6, padding: '3px 6px', fontSize: 13, fontWeight: 600, outline: 'none' }} />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 14px' }}>
                        <span style={{ fontSize: 11, color: '#a0aab8', textTransform: 'uppercase' }}>End Year</span>
                        <input type="number" min="2000" max="2100" value={endYear} onChange={handleEndYearInput}
                          style={{ width: 60, border: '1px solid #e5e7eb', borderRadius: 6, padding: '3px 6px', fontSize: 13, fontWeight: 600, outline: 'none' }} />
                      </div>
                    </div>
                    <div style={{ padding: '6px 14px', background: '#fafafa', borderBottom: '1px solid #ebedf2', fontSize: 11, color: '#a0aab8' }}>
                      {pickStep === 'start' ? '← Pick start month' : '← Pick end month'}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      <div style={{ borderRight: '1px solid #ebedf2' }}>
                        <div style={{ fontSize: 10, color: '#a0aab8', textTransform: 'uppercase', letterSpacing: '0.06em', padding: '8px 14px 4px', background: '#fafafa', borderBottom: '1px solid #ebedf2' }}>Start</div>
                        <div style={{ overflowY: 'auto', maxHeight: 200 }}>
                          {MONTHS.map((mon, idx) => {
                            const isSelected = idx === startMonth;
                            return (
                              <div key={mon} onClick={() => { setStartMonth(idx); if (startYear === endYear && endMonth !== null && endMonth < idx) setEndMonth(null); setPickStep('end'); }}
                                style={{ padding: '9px 14px', fontSize: 13, cursor: 'pointer', background: isSelected ? '#7c3aed' : 'transparent', color: isSelected ? '#fff' : '#374151', fontWeight: isSelected ? 600 : 400, borderBottom: '1px solid #f3f4f6' }}
                                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f3f0ff'; }}
                                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}>
                                {mon} {startYear}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div>
                        <div style={{ fontSize: 10, color: '#a0aab8', textTransform: 'uppercase', letterSpacing: '0.06em', padding: '8px 14px 4px', background: '#fafafa', borderBottom: '1px solid #ebedf2' }}>End</div>
                        <div style={{ overflowY: 'auto', maxHeight: 200 }}>
                          {MONTHS.map((mon, idx) => {
                            const isSelected = idx === endMonth;
                            const disabled = startYear === endYear && idx < startMonth;
                            return (
                              <div key={mon} onClick={() => { if (disabled) return; setEndMonth(idx); setPickStep('start'); }}
                                style={{ padding: '9px 14px', fontSize: 13, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.35 : 1, background: isSelected ? '#7c3aed' : 'transparent', color: isSelected ? '#fff' : '#374151', fontWeight: isSelected ? 600 : 400, borderBottom: '1px solid #f3f4f6' }}
                                onMouseEnter={e => { if (!disabled && !isSelected) e.currentTarget.style.background = '#f3f0ff'; }}
                                onMouseLeave={e => { if (!disabled && !isSelected) e.currentTarget.style.background = 'transparent'; }}>
                                {mon} {endYear}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div style={{ padding: '9px 14px', borderTop: '1px solid #ebedf2', background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 12, color: '#888' }}>
                        {endMonth !== null
                          ? <><b>{MONTHS[startMonth]} {startYear}</b> – <b>{MONTHS[endMonth]} {endYear}</b></>
                          : `${MONTHS[startMonth]} ${startYear} → pick end`}
                      </span>
                      <button disabled={endMonth === null} onClick={handleApply}
                        style={{ background: endMonth !== null ? '#7c3aed' : '#e5e7eb', color: endMonth !== null ? '#fff' : '#aaa', border: 'none', borderRadius: 8, padding: '6px 16px', fontSize: 13, fontWeight: 500, cursor: endMonth !== null ? 'pointer' : 'default' }}>
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <button className="topnav-export-btn" onClick={onExportPDF} disabled={exporting}>
                <IconExport />Export
              </button>
            </>
          )}

          {/* ── NEW: Reminder Bell (shows on ALL admin pages) ── */}
          <div ref={reminderRef} style={{ position: 'relative' }}>
            <button
  onClick={() => setReminderOpen(o => !o)}
  className="topnav-logout-btn"
  style={{ background: '#02133F', position: 'relative', display: 'flex', alignItems: 'center', gap: 7 }}
>
  <img src="/dol.png" alt="reminder" style={{ width: 18, height: 18, objectFit: 'contain' }} />
  Remainder
              {reminderData.count > 0 && (
                <span style={{
                  position: 'absolute', top: -6, right: -6,
                  background: '#ef4444', color: '#fff',
                  borderRadius: '50%', width: 18, height: 18,
                  fontSize: '0.68rem', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontWeight: 700, lineHeight: 1
                }}>
                  {reminderData.count}
                </span>
              )}
            </button>

            {/* ── Reminder Dropdown ── */}
            {reminderOpen && (
  <div style={{
    position: 'absolute', top: 'calc(100% + 10px)', right: 0,
    background: '#fff', borderRadius: 14,
    boxShadow: '0 8px 32px rgba(0,0,0,0.13)',
    width: 370, zIndex: 9999,
    border: '1px solid #f1f5f9', overflow: 'hidden'
  }}>
    {/* ── Header ── */}
    <div style={{
      padding: '13px 18px', borderBottom: '1px solid #f1f5f9',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: '#fafbff'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: '1.1rem' }}>📅</span>
        <div>
          <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.92rem' }}>
            Expiring Reminder
          </div>
          
        </div>
      </div>
      <span style={{
        background: reminderData.count > 0 ? '#FEE2E2' : '#DCFCE7',
        color: reminderData.count > 0 ? '#dc2626' : '#16a34a',
        borderRadius: 20, padding: '3px 12px',
        fontSize: '0.78rem', fontWeight: 700
      }}>
        {reminderData.count} Expiring
      </span>
    </div>

    {/* ── Month Filter Tabs ── */}
    <div style={{
      display: 'flex', gap: 8, padding: '10px 14px',
      borderBottom: '1px solid #f1f5f9', background: '#fafbff'
    }}>
      {[
        { key: 'all',  label: 'All' },
        { key: 'this', label: `This Month (${reminderData.reminderMonth?.split('–')[0]?.trim()})` },
        { key: 'next', label: `Next Month (${reminderData.reminderMonth?.split('–')[1]?.trim()})` },
      ].map(tab => (
        <button
          key={tab.key}
          onClick={() => setReminderFilter(tab.key)}
          style={{
            padding: '5px 12px', borderRadius: 20, fontSize: '0.75rem',
            fontWeight: 600, border: 'none', cursor: 'pointer',
            background: reminderFilter === tab.key ? '#7c3aed' : '#f1f5f9',
            color: reminderFilter === tab.key ? '#fff' : '#64748b',
            transition: 'all 0.15s'
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>

    {/* ── List ── */}
    <div style={{ maxHeight: 340, overflowY: 'auto' }}>
      {(() => {
        const filtered = reminderData.organizations.filter(org => {
          if (reminderFilter === 'all')  return true;
          if (reminderFilter === 'this') return org.status === 'Expiring This Month';
          if (reminderFilter === 'next') return org.status === 'Expiring Next Month';
          return true;
        });

        if (filtered.length === 0) return (
          <div style={{ textAlign: 'center', padding: '28px 20px', color: '#94a3b8' }}>
            <div style={{ fontSize: '1.8rem', marginBottom: 8 }}>✅</div>
            <div style={{ fontWeight: 600, color: '#475569' }}>All clear!</div>
            <div style={{ fontSize: '0.8rem', marginTop: 4 }}>No certifications expiring</div>
          </div>
        );

        return filtered.map((org, idx) => {
          const s = TYPE_STYLES[org.type] || { bg: '#F8FAFC', color: '#64748b' };
          const icon = TYPE_ICONS[org.type] || '/people-skin-type.png';
          return (
            <div key={idx} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: '11px 18px',
              borderBottom: idx < filtered.length - 1 ? '1px solid #f8fafc' : 'none',
              transition: 'background 0.15s'
            }}
              onMouseEnter={e => e.currentTarget.style.background = '#f8faff'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{
                width: 38, height: 38, borderRadius: 10,
                background: s.bg, flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <img src={icon} alt={org.type} style={{ width: 22, height: 22, objectFit: 'contain' }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.88rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {org.name}
                </div>
                <div style={{ color: '#94a3b8', fontSize: '0.76rem', marginTop: 2 }}>
                  {org.certification_period}
                </div>
                {/* ── expiry status tag ── */}
                <div style={{
                  fontSize: '0.7rem', fontWeight: 600, marginTop: 3,
                  color: org.status === 'Expiring This Month' ? '#dc2626' : '#d97706'
                }}>
                  ⚠ {org.status}
                </div>
              </div>
              <span style={{
                background: s.bg, color: s.color,
                borderRadius: 6, padding: '2px 9px',
                fontSize: '0.72rem', fontWeight: 600, flexShrink: 0
              }}>
                {org.type}
              </span>
            </div>
          );
        });
      })()}
    </div>
  </div>
)}
          </div>

          {/* Logout */}
          <button className="topnav-logout-btn" onClick={handleLogout}>
            <IconLogout />Logout
          </button>
        </div>
      </header>
    </>
  );
}